import React from 'react';
import { Icon, Spinner } from '@scentregroup/ui';
import { Box } from '@hub/box';
import { Text } from '@hub/text';
import { useNearestCentres } from '@scentregroup/shared/hooks/use-nearest-centres';
import style from './index.module.scss';
import CentreLinks from './centre-links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuggestedCentres = _ref => {
  let {
    centres,
    mode
  } = _ref;
  const [{
    loadingLocation,
    suggestedCentres
  }, getSuggestedCentresNearMe] = useNearestCentres(centres);
  return /*#__PURE__*/_jsxs(Box, {
    "data-id": "new-centre-selector_suggested-centres_SuggestedCentres_Box",
    children: [/*#__PURE__*/_jsxs("button", {
      className: style['use-location'],
      onClick: getSuggestedCentresNearMe,
      "data-id": "new-centre-selector_suggested-centres_SuggestedCentres_Box_button",
      children: [/*#__PURE__*/_jsx(Icon, {
        type: "location-drop-pin",
        size: "small",
        className: style.UseLocationIcon,
        "data-id": "new-centre-selector_suggested-centres_SuggestedCentres_button_Icon"
      }), /*#__PURE__*/_jsx(Text, {
        sx: {
          paddingLeft: mode === 'search' ? 'spacing-md' : undefined,
          fontSize: 'font-md'
        },
        "data-id": "new-centre-selector_suggested-centres_SuggestedCentres_button_Text",
        children: "Or use your current location"
      }), loadingLocation && /*#__PURE__*/_jsx("div", {
        className: style['spinner-container'],
        "data-id": "new-centre-selector_suggested-centres_SuggestedCentres_div",
        children: /*#__PURE__*/_jsx(Spinner, {
          "data-id": "new-centre-selector_suggested-centres_SuggestedCentres_div_Spinner"
        })
      })]
    }), suggestedCentres.length ? /*#__PURE__*/_jsx(CentreLinks, {
      mode: mode,
      header: "Suggested",
      centres: suggestedCentres,
      "data-id": "new-centre-selector_suggested-centres_SuggestedCentres_CentreLinks"
    }) : null]
  });
};
export default SuggestedCentres;